module.exports = __webpack_public_path__ + "dark-material-bg.d914334bfb315da0efe3.jpg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/images/backgrounds/dark-material-bg.jpg
// module id = ../../../../../src/assets/images/backgrounds/dark-material-bg.jpg
// module chunks = main